import { Button } from '@/components/ui/button';
import { Home, ArrowLeft, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useAuth } from '@/hooks/auth/use-auth';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-lg mx-auto text-center">
        {/* 404 Text with Animation */}
        <div className="relative">
          <h1
            className="text-[150px] font-bold text-gray-100 select-none"
            style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}
          >
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="space-y-2">
              <h2 className="text-4xl font-bold" style={{ color: '#5777BA' }}>
                Page Not Found
              </h2>
              <p className="text-gray-500">
                The page you're looking for doesn't exist or has been moved.
              </p>
            </div>
          </div>
        </div>

        {/* Illustration */}
        <div className="my-8 relative">
          <div className="w-32 h-32 mx-auto bg-[#5777BA] rounded-full opacity-10 animate-pulse" />
          <div className="w-24 h-24 mx-auto bg-[#5777BA] rounded-full opacity-20 absolute top-4 left-1/2 -translate-x-1/2 animate-pulse delay-100" />
          <div className="w-16 h-16 mx-auto bg-[#5777BA] rounded-full opacity-30 absolute top-8 left-1/2 -translate-x-1/2 animate-pulse delay-200" />
        </div>

        {/* Actions */}
        <div className="space-y-3 mt-8">
          <Button
            variant="default"
            size="lg"
            className="w-full bg-[#5777BA] hover:bg-[#4a69b0] transition-all duration-200"
            onClick={() => navigate('/')}
          >
            <Home className="mr-2 h-5 w-5" />
            Back to Dashboard
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full border-[#5777BA] text-[#5777BA] hover:bg-[#5777BA] hover:text-white transition-all duration-200"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Go Back
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full border-red-500 text-red-500 hover:bg-red-500 hover:text-white transition-all duration-200"
            onClick={logout}
          >
            <LogOut className="mr-2 h-5 w-5" />
            Logout
          </Button>
        </div>

        {/* Help Text */}
        <p className="mt-8 text-sm text-gray-500">
          If you believe this is a mistake, please contact support.
        </p>
      </div>
    </div>
  );
}
